(function () {
  var MQ = '(max-width: 779px)';
  var FALLBACK = '#f5f5f5';
  var SCROLL_THRESHOLD = 12;
  var applied = '';
  var scrolled = false;

  function isProductMobile() {
    return document.body.classList.contains('template-product') && window.matchMedia(MQ).matches;
  }

  function findMainImage() {
    var selectors = [
      '.pebble-product-media__mobile .swiper-slide-active img',
      '.pebble-product-media__mobile .pebble-product-media__slide.is-active img',
      '.pebble-product-media__mobile .swiper-slide:not(.swiper-slide-duplicate) img',
      '.pebble-product-media__mobile img',
      '.main-product--pebble .product__media img',
    ];
    for (var i = 0; i < selectors.length; i++) {
      var nodes = document.querySelectorAll(selectors[i]);
      for (var j = 0; j < nodes.length; j++) {
        var img = nodes[j];
        if (img.naturalWidth > 0 && img.complete) return img;
      }
    }
    return null;
  }

  function readAverage(sourceImg) {
    try {
      var nw = sourceImg.naturalWidth || 0;
      var nh = sourceImg.naturalHeight || 0;
      if (!nw || !nh) return null;
      var w = Math.min(nw, 160);
      var h = Math.min(12, Math.max(4, Math.round(nh * (8 / Math.max(nh, 1)))));
      var canvas = document.createElement('canvas');
      canvas.width = w;
      canvas.height = h;
      var ctx = canvas.getContext('2d', { willReadFrequently: true });
      if (!ctx) return null;
      ctx.drawImage(sourceImg, 0, 0, nw, h, 0, 0, w, h);
      var data = ctx.getImageData(0, 0, w, h).data;
      var r = 0;
      var g = 0;
      var b = 0;
      var n = 0;
      for (var i = 0; i < data.length; i += 4) {
        if (data[i + 3] < 200) continue;
        r += data[i];
        g += data[i + 1];
        b += data[i + 2];
        n++;
      }
      if (!n) return null;
      return (
        'rgb(' +
        Math.round(r / n) +
        ',' +
        Math.round(g / n) +
        ',' +
        Math.round(b / n) +
        ')'
      );
    } catch (e) {
      return null;
    }
  }

  function averageTopColor(img, done) {
    var direct = readAverage(img);
    if (direct) {
      done(direct);
      return;
    }

    var src = img.currentSrc || img.src;
    if (!src) {
      done(FALLBACK);
      return;
    }
    var probe = new Image();
    probe.crossOrigin = 'anonymous';
    probe.decoding = 'async';
    probe.onload = function () {
      done(readAverage(probe) || FALLBACK);
    };
    probe.onerror = function () {
      done(FALLBACK);
    };
    var joiner = src.indexOf('?') >= 0 ? '&' : '?';
    probe.src = src + joiner + 'pebble-tint=1';
  }

  function headerNodes() {
    return document.querySelectorAll(
      '#shopify-header-section.header--pebble, #shopify-header-section.header--pebble .header, #shopify-header-section.header--pebble header-js, #shopify-header-section.header--pebble sticky-header, #shopify-header-section.header--pebble .header-pebble-bar'
    );
  }

  function paintHeader(color) {
    var nodes = headerNodes();
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].style.setProperty('background', color, 'important');
    }
  }

  function clearHeaderPaint() {
    var nodes = headerNodes();
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].style.removeProperty('background');
    }
  }

  function syncScrollState() {
    if (!isProductMobile() || !applied) {
      scrolled = false;
      document.body.classList.remove('pebble-pdp-header-scrolled');
      return;
    }

    var next = window.scrollY > SCROLL_THRESHOLD;
    scrolled = next;
    document.body.classList.toggle('pebble-pdp-header-scrolled', next);

    if (next) {
      clearHeaderPaint();
    } else {
      paintHeader(applied);
    }
  }

  function applyColor(color) {
    if (!isProductMobile()) {
      clearColor();
      return;
    }
    applied = color;
    document.documentElement.style.setProperty('--pebble-pdp-header-bg', color);
    document.body.classList.add('pebble-pdp-header-tint');
    syncScrollState();
  }

  function clearColor() {
    applied = '';
    scrolled = false;
    document.documentElement.style.removeProperty('--pebble-pdp-header-bg');
    document.body.classList.remove('pebble-pdp-header-tint');
    document.body.classList.remove('pebble-pdp-header-scrolled');
    clearHeaderPaint();
  }

  function refresh() {
    if (!isProductMobile()) {
      clearColor();
      return;
    }
    var img = findMainImage();
    if (!img) {
      applyColor(FALLBACK);
      return;
    }
    if (!img.complete || img.naturalWidth === 0) {
      img.addEventListener(
        'load',
        function () {
          refresh();
        },
        { once: true }
      );
      applyColor(FALLBACK);
      return;
    }
    averageTopColor(img, applyColor);
  }

  var timer;
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(refresh, 40);
  }

  function bindGallery() {
    var root = document.querySelector('.pebble-product-media, .main-product--pebble');
    if (!root || root.dataset.pebbleHeaderTintBound === 'true') return;
    root.dataset.pebbleHeaderTintBound = 'true';

    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-pebble-grid-thumb], .pebble-product-media__mobile-thumb, .swiper-pagination-bullet')) {
        schedule();
      }
    });

    var carousel = root.querySelector('.pebble-product-media__carousel');
    if (carousel) {
      carousel.addEventListener('touchend', schedule, { passive: true });
      carousel.addEventListener('transitionend', schedule, { passive: true });
      if (typeof MutationObserver !== 'undefined') {
        new MutationObserver(schedule).observe(carousel, {
          subtree: true,
          attributes: true,
          attributeFilter: ['class', 'style'],
        });
      }
    }
  }

  function bindScroll() {
    if (document.documentElement.dataset.pebblePdpHeaderScrollBound === 'true') return;
    document.documentElement.dataset.pebblePdpHeaderScrollBound = 'true';
    window.addEventListener('scroll', syncScrollState, { passive: true });
  }

  function init() {
    if (!document.body.classList.contains('template-product')) return;
    bindGallery();
    bindScroll();
    refresh();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('load', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('.pebble-product-media, .main-product--pebble').forEach(function (el) {
      delete el.dataset.pebbleHeaderTintBound;
    });
    init();
  });

  setTimeout(schedule, 200);
  setTimeout(schedule, 600);
  setTimeout(schedule, 1500);
})();
